import React from 'react';
import { Link } from 'react-router-dom';
import packageJson from '../../package.json';
import { useTenantFromUrl } from '../hooks/useTenantFromUrl';
import { isAuthenticated } from '../services/auth';
import './AboutPage.css';

const buildSha = process.env.REACT_APP_BUILD_SHA || '';
const buildId = process.env.REACT_APP_BUILD_ID || '';
const displaySha = buildSha.length > 7 ? `${buildSha.slice(0, 7)}…` : buildSha;

function AboutPage() {
  const { tenantCode, tenantPath } = useTenantFromUrl();
  const version = process.env.REACT_APP_VERSION || packageJson.version;
  const year = new Date().getFullYear();
  const backTo = isAuthenticated() && tenantCode ? tenantPath('/dashboard') : '/login';
  const backLabel = isAuthenticated() ? 'Back to app' : 'Back to login';

  return (
    <div className="about-page">
      <div className="about-page-card">
        <h1 className="about-page-title">About Child Family Connect</h1>
        <p className="about-page-lead">
          A web application for coordinating care, referrals, and documentation for children and families.
        </p>

        <dl className="about-page-meta">
          <div className="about-page-meta-row">
            <dt>Version</dt>
            <dd>{version}</dd>
          </div>
          <div className="about-page-meta-row">
            <dt>Build</dt>
            <dd>
              {buildId || buildSha ? (
                <>
                  {buildId && <span title="GitHub Actions run id">Run {buildId}</span>}
                  {buildId && displaySha ? ' · ' : null}
                  {displaySha && (
                    <span className="about-page-mono" title={buildSha || undefined}>
                      {displaySha}
                    </span>
                  )}
                </>
              ) : (
                <span className="about-page-muted">Local development (not set)</span>
              )}
            </dd>
          </div>
        </dl>

        <p className="about-page-copyright">
          © {year} Huensch Computer Consulting Inc. All rights reserved.
        </p>

        <p className="about-page-back">
          <Link to={backTo} className="link-nav">
            {backLabel}
          </Link>
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
